// Service pour l'intégration avec Google Drive

// Configuration
const CLIENT_ID = '103093524461-j83elmjn5ffn63d44rqf5qie8eutjbc7.apps.googleusercontent.com';
const API_KEY = 'AIzaSyBRAZmj4Xexjogk2ZL0K9ZlQaOF217FsrM';
const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';
const SCOPES = 'https://www.googleapis.com/auth/drive.file';
// L'autre solution (permettant des fonctionnalités crud sur drive) est trop galère, google me demande de faire une vidéo avec les fonctionnalités de l'app.
// const SCOPES = 'https://www.googleapis.com/auth/drive';

let isGapiInitialized = false;
let isGisInitialized = false;
let tokenClient;
let pickerInited = false;

/**
 * Détecter l'environnement actuel
 */
function getCurrentEnvironment() {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  console.log(`🌐 Environnement détecté: ${protocol}//${hostname}`);

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  } else if (hostname === 'meuthopik.com') {
    return 'production';
  } else {
    return 'unknown';
  }
}

/**
 * Initialiser Google Picker
 */
async function initializePicker() {
  if (pickerInited) return;

  try {
    if (typeof gapi === 'undefined') {
      throw new Error('GAPI non disponible pour Google Picker');
    }

    await new Promise((resolve, reject) => {
      gapi.load('picker', {
        callback: () => {
          console.log('✅ Google Picker chargé');
          resolve();
        },
        onerror: (error) => {
          console.error('❌ Erreur chargement Google Picker:', error);
          reject(error);
        }
      });
    });

    pickerInited = true;
    console.log('✅ Google Picker initialisé');
  } catch (error) {
    console.error('❌ Erreur initialisation Google Picker:', error);
    throw error;
  }
}

/**
 * Initialiser l'API Google
 */
export async function initializeGoogleAPI() {
  try {
    const env = getCurrentEnvironment();
    console.log(`🔧 Initialisation API Google pour: ${env}`);

    // Vérifier si gapi est disponible
    if (typeof gapi === 'undefined') {
      throw new Error('API Google non chargée. Vérifiez que le script est inclus dans index.html');
    }

    // Initialiser gapi
    await new Promise((resolve, reject) => {
      gapi.load('client', {
        callback: resolve,
        onerror: reject
      });
    });

    await gapi.client.init({
      apiKey: API_KEY,
      discoveryDocs: [DISCOVERY_DOC],
    });

    isGapiInitialized = true;

    // Vérifier si Google Identity Services est disponible
    if (typeof google === 'undefined' || !google.accounts) {
      throw new Error('Google Identity Services non chargé');
    }

    // Initialiser Google Identity Services
    tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      callback: '', // sera défini lors de l'utilisation
      error_callback: (error) => {
        console.error('❌ Erreur OAuth:', error);
      }
    });

    isGisInitialized = true;

    // Initialiser Google Picker
    await initializePicker();

    console.log('✅ API Google Drive et Picker initialisées');
    return true;
  } catch (error) {
    console.error('❌ Erreur lors de l\'initialisation:', error);
    throw error;
  }
}

/**
 * Authentifier l'utilisateur avec Google
 */
export function authenticateUser() {
  return new Promise((resolve, reject) => {
    tokenClient.callback = async (resp) => {
      console.log('📝 Réponse OAuth:', resp);

      if (resp.error !== undefined) {
        console.error('❌ Erreur d\'authentification:', resp.error);

        let errorMessage = '';
        if (resp.error === 'access_denied') {
          errorMessage = '🚫 Accès refusé à Google Drive.\n\nVous avez refusé l\'autorisation ou l\'application n\'est pas configurée correctement.';
        } else {
          errorMessage = `❌ Erreur d'authentification: ${resp.error}`;
        }

        reject(new Error(errorMessage));
        return;
      }

      try {
        // AMÉLIORER la sauvegarde du token
        const tokenToSave = {
          access_token: resp.access_token,
          expires_in: resp.expires_in || 3600, // Par défaut 1 heure
          scope: resp.scope,
          token_type: resp.token_type || 'Bearer',
          saved_at: Date.now()
        };

        await saveGoogleToken(tokenToSave);
        console.log('✅ Token sauvegardé avec succès');

        resolve(true);
      } catch (error) {
        console.error('❌ Erreur sauvegarde token:', error);
        // Continuer même si la sauvegarde échoue
        resolve(true);
      }
    };

    try {
      if (gapi.client.getToken() === null) {
        console.log('🚀 Demande de nouveau token...');
        tokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        console.log('🔄 Token déjà présent, vérification...');
        resolve(true);
      }
    } catch (error) {
      console.error('❌ Erreur lors de la demande de token:', error);
      reject(error);
    }
  });
}

/**
 * Vérifier et restaurer l'authentification Google au démarrage
 */
export async function restoreGoogleAuth() {
  try {
    console.log('🔄 Vérification authentification Google...');

    const savedToken = await loadGoogleToken();

    if (savedToken) {
      console.log('🔑 Token trouvé, restauration...');

      gapi.client.setToken(savedToken);

      try {
        await gapi.client.drive.files.list({ pageSize: 1 });
        console.log('✅ Authentification restaurée avec succès');
        return true;
      } catch (error) {
        console.log('❌ Token invalide, suppression...');
        await clearGoogleToken();
        return false;
      }
    } else {
      console.log('🚫 Aucun token sauvegardé');
      return false;
    }
  } catch (error) {
    console.error('❌ Erreur restauration auth:', error);
    return false;
  }
}

/**
 * Choisir un dossier avec Google Picker
 */
export async function selectFolder() {
  try {
    const env = getCurrentEnvironment();
    console.log(`📁 Sélection de dossier pour: ${env}`);

    // Vérifier que Google Picker est disponible
    if (typeof google === 'undefined' || !google.picker) {
      throw new Error('Google Picker API non disponible. Vérifiez que le script est chargé.');
    }

    if (!pickerInited) {
      await initializePicker();
    }

    if (!gapi.client.getToken()) {
      console.log('🔐 Authentification requise pour le picker');
      await authenticateUser();
    }

    const token = gapi.client.getToken();
    if (!token || !token.access_token) {
      throw new Error('Token d\'accès non disponible pour Google Picker');
    }

    console.log('🚀 Ouverture du sélecteur de dossiers...');

    return new Promise((resolve, reject) => {
      try {
        const picker = new google.picker.PickerBuilder()
          .addView(new google.picker.DocsView(google.picker.ViewId.FOLDERS)
            .setSelectFolderEnabled(true)
            .setIncludeFolders(true))
          .setOAuthToken(token.access_token)
          .setDeveloperKey(API_KEY)
          .setCallback((data) => {
            console.log('📋 Réponse du picker:', data);

            if (data.action === google.picker.Action.PICKED) {
              const folder = data.docs[0];
              console.log('📁 Dossier sélectionné:', folder);
              resolve({
                id: folder.id,
                name: folder.name
              });
            } else if (data.action === google.picker.Action.CANCEL) {
              console.log('🚫 Sélection annulée');
              resolve(null);
            } else {
              console.log('ℹ️ Action picker:', data.action);
            }
          })
          .build();

        picker.setVisible(true);
      } catch (error) {
        console.error('❌ Erreur création picker:', error);
        reject(error);
      }
    });
  } catch (error) {
    console.error('❌ Erreur lors de la sélection du dossier:', error);

    // Message d'erreur plus explicite pour l'utilisateur
    let errorMessage = 'Erreur lors de l\'ouverture du sélecteur de dossiers.\n\n';

    if (error.message.includes('Google Picker API non disponible')) {
      errorMessage += 'Le sélecteur de dossiers Google n\'est pas disponible.\n';
      errorMessage += 'Utilisez la sauvegarde dans la racine ou les autres options.';
    } else if (error.message.includes('Token')) {
      errorMessage += 'Problème d\'authentification Google.\n';
      errorMessage += 'Essayez de vous reconnecter.';
    } else {
      errorMessage += 'Détails techniques: ' + error.message;
    }

    throw new Error(errorMessage);
  }
}

/**
 * Sauvegarder un fichier sur Google Drive (RACINE UNIQUEMENT)
 */
export async function saveToGoogleDrive(data, filename) {
  try {

    // Vérifier l'authentification
    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    const fileMetadata = {
      name: filename,
      parents: [], // Racine du Drive
    };

    const form = new FormData();
    form.append('metadata', new Blob([JSON.stringify(fileMetadata)], { type: 'application/json' }));
    form.append('file', new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));

    const response = await fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
      method: 'POST',
      headers: new Headers({
        'Authorization': `Bearer ${gapi.client.getToken().access_token}`
      }),
      body: form
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Erreur HTTP ${response.status}: ${errorText}`);
    }

    const result = await response.json();
    console.log('✅ Fichier sauvegardé:', result);
    return result;
  } catch (error) {
    console.error('❌ Erreur lors de la sauvegarde:', error);
    throw error;
  }
}

/**
 * Sauvegarder un fichier sur Google Drive dans un dossier spécifique
 */
export async function saveToGoogleDriveWithFolder(data, filename, folderId) {
  try {
    console.log('💾 Sauvegarde sur Google Drive dans dossier spécifique...');

    // Vérifier l'authentification
    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    const fileMetadata = {
      name: filename,
      parents: folderId ? [folderId] : [], // Dossier spécifique ou racine
    };

    const form = new FormData();
    form.append('metadata', new Blob([JSON.stringify(fileMetadata)], { type: 'application/json' }));
    form.append('file', new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));

    const response = await fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
      method: 'POST',
      headers: new Headers({
        'Authorization': `Bearer ${gapi.client.getToken().access_token}`
      }),
      body: form
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Erreur HTTP ${response.status}: ${errorText}`);
    }

    const result = await response.json();
    console.log('✅ Fichier sauvegardé:', result);
    return result;
  } catch (error) {
    console.error('❌ Erreur lors de la sauvegarde:', error);
    throw error;
  }
}

/**
 * Lister les fichiers de l'application sur Google Drive
 */
export async function listAppFiles() {
  try {
    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    const response = await gapi.client.drive.files.list({
      q: "name contains 'backup-heures-meuthopik' and trashed=false",
      fields: 'files(id, name, createdTime, modifiedTime, parents, mimeType, size)',
      orderBy: 'modifiedTime desc'
    });

    const files = response.result.files || [];

    // Enrichir chaque fichier avec le chemin complet
    const enrichedFiles = await Promise.all(files.map(async (file) => {
      const path = await getFilePath(file);
      return {
        ...file,
        fullPath: path
      };
    }));

    return enrichedFiles;
  } catch (error) {
    console.error('Erreur lors de la récupération des fichiers:', error);
    throw error;
  }
}

/**
 * Récupérer le chemin d'un dossier de manière récursive
 */
async function getFolderPath(folderId, visited = new Set()) {
  try {
    if (folderId === 'root' || !folderId) {
      return '/'; // Racine
    }

    // Éviter les boucles infinies
    if (visited.has(folderId)) {
      console.warn(`⚠️ Boucle détectée pour le dossier ${folderId}`);
      return '/dossier-boucle';
    }
    visited.add(folderId);

    const folderInfo = await gapi.client.drive.files.get({
      fileId: folderId,
      fields: 'id, name, parents'
    });

    const folder = folderInfo.result;

    if (!folder.parents || folder.parents.length === 0 || folder.parents[0] === 'root') {
      return folder.name;
    }

    // Récursion pour obtenir le chemin parent
    const parentPath = await getFolderPath(folder.parents[0], visited);

    if (parentPath === '/') {
      return folder.name;
    } else {
      return `${parentPath}/${folder.name}`;
    }
  } catch (error) {
    // ✅ AMÉLIORER : Log silencieux pour éviter le spam
    if (error.status === 404) {
      console.info(`📁 Dossier ${folderId} n'existe plus - chemin ignoré`);
      return '/dossier-supprime';
    } else {
      console.warn(`⚠️ Accès dossier ${folderId} impossible:`, error.status || error.message);
      return '/dossier-inaccessible';
    }
  }
}

/**
 * Obtenir le chemin complet d'un fichier dans Google Drive
 */
export async function getFilePath(file) {
  try {
    if (!file.parents || file.parents.length === 0) {
      return '/'; // Racine
    }

    const parentId = file.parents[0];
    if (parentId === 'root') {
      return '/'; // Racine
    }

    // ✅ AMÉLIORER : Récupération avec gestion d'erreur silencieuse
    const folderPath = await getFolderPath(parentId);
    return folderPath;
  } catch (error) {
    // Log silencieux pour éviter le spam
    console.info(`📄 Chemin du fichier ${file.name} non récupérable - utilisation racine`);
    return '/';
  }
}

/**
 * Télécharger un fichier depuis Google Drive
 */
export async function downloadFromGoogleDrive(fileId) {
  try {
    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    const response = await gapi.client.drive.files.get({
      fileId: fileId,
      alt: 'media'
    });

    return JSON.parse(response.body);
  } catch (error) {
    console.error('Erreur lors du téléchargement depuis Google Drive:', error);
    throw error;
  }
}

/**
 * Se déconnecter de Google
 */
export async function signOutGoogle() {
  try {
    const token = gapi.client.getToken();
    if (token !== null) {
      google.accounts.oauth2.revoke(token.access_token);
      gapi.client.setToken('');
    }

    // Supprimer le token sauvegardé
    await clearGoogleToken();
    console.log('✅ Token supprimé du stockage local');

  } catch (error) {
    console.error('❌ Erreur lors de la déconnexion:', error);
    throw error;
  }
}

/**
 * Lister TOUS les fichiers JSON dans un dossier spécifique (VERSION CORRIGÉE)
 */
export async function listAppFilesInFolder(folderId = null) {
  try {
    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    console.log(`🔍 === NOUVELLE VERSION CORRIGÉE ===`);
    console.log(`🔍 Recherche dans le dossier ID: ${folderId}`);

    // NOUVELLE APPROCHE : Requête sans guillemets et plus simple
    let query;
    if (folderId) {
      // Essayer différentes syntaxes de requête
      query = `${folderId} in parents and trashed=false`;
    } else {
      query = "trashed=false and 'root' in parents";
    }

    console.log('🔍 Nouvelle requête simplifiée:', query);

    const response = await gapi.client.drive.files.list({
      q: query,
      fields: 'nextPageToken, files(id, name, createdTime, modifiedTime, parents, mimeType, size)',
      orderBy: 'modifiedTime desc',
      pageSize: 100,
      supportsAllDrives: true,  // AJOUTER SUPPORT DRIVES PARTAGÉS
      includeItemsFromAllDrives: true  // INCLURE TOUS LES DRIVES
    });

    console.log('📡 Réponse API (nouvelle version):', response);
    console.log(`📂 Fichiers trouvés (nouvelle version): ${response.result.files?.length || 0}`);

    const allFiles = response.result.files || [];

    if (allFiles.length === 0) {
      console.log('❌ Toujours 0 fichiers - Essayer requête alternative...');

      // REQUÊTE ALTERNATIVE avec syntaxe différente
      const altQuery = folderId ? `parents in "${folderId}" and trashed=false` : "trashed=false";
      console.log('🔄 Requête alternative:', altQuery);

      const altResponse = await gapi.client.drive.files.list({
        q: altQuery,
        fields: 'files(id, name, mimeType)',
        pageSize: 50,
        supportsAllDrives: true,
        includeItemsFromAllDrives: true
      });

      console.log('📡 Réponse alternative:', altResponse);
      console.log(`📂 Fichiers alternatifs: ${altResponse.result.files?.length || 0}`);

      if (altResponse.result.files?.length > 0) {
        return altResponse.result.files.filter(file =>
          file.name.toLowerCase().includes('.json') ||
          file.mimeType === 'application/json'
        );
      }
    }

    // Log détaillé de chaque fichier
    allFiles.forEach((file, index) => {
      console.log(`📄 ${index + 1}. ${file.name} (${file.mimeType || 'unknown'})`);
    });

    // Filtrer les JSON
    const jsonFiles = allFiles.filter(file => {
      const fileName = file.name.toLowerCase();
      return fileName.includes('.json') || file.mimeType === 'application/json';
    });

    console.log(`📋 Fichiers JSON trouvés: ${jsonFiles.length}`);
    return jsonFiles;

  } catch (error) {
    console.error('❌ Erreur lors de la recherche:', error);

    // DERNIÈRE TENTATIVE : Recherche très basique
    if (folderId) {
      try {
        console.log('🔄 Dernière tentative - recherche basique...');
        const basicResponse = await gapi.client.drive.files.list({
          q: "trashed=false",
          fields: 'files(id, name, parents, mimeType)',
          pageSize: 1000
        });

        // Filtrer côté client
        const filesInFolder = basicResponse.result.files.filter(file =>
          file.parents && file.parents.includes(folderId)
        );

        console.log(`📂 Fichiers trouvés par recherche basique: ${filesInFolder.length}`);

        const jsonFiles = filesInFolder.filter(file =>
          file.name.toLowerCase().includes('.json') ||
          file.mimeType === 'application/json'
        );

        console.log(`📋 JSON trouvés par recherche basique: ${jsonFiles.length}`);
        return jsonFiles;

      } catch (basicError) {
        console.error('❌ Même la recherche basique échoue:', basicError);
      }
    }

    throw error;
  }
}

/**
 * Debug - Lister TOUS les fichiers dans un dossier
 */
export async function debugListAllFilesInFolder(folderId) {
  try {
    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    const query = folderId ? `'${folderId}' in parents and trashed=false` : "trashed=false";

    const response = await gapi.client.drive.files.list({
      q: query,
      fields: 'files(id, name, createdTime, modifiedTime, mimeType, size)',
      orderBy: 'modifiedTime desc'
    });

    console.log('🔍 DEBUG - TOUS les fichiers dans le dossier:', response.result.files);
    return response.result.files;
  } catch (error) {
    console.error('Erreur debug:', error);
    throw error;
  }
}

/**
 * Lister TOUS les fichiers dans un dossier (presque aucun filtre)
 */
export async function listAllFilesInFolder(folderId = null) {
  try {
    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    let query = "trashed=false";
    if (folderId) {
      query += ` and '${folderId}' in parents`;
    } else {
      query += " and 'root' in parents";
    }

    console.log('🔍 Requête ultra-simple:', query);

    const response = await gapi.client.drive.files.list({
      q: query,
      fields: 'files(id, name, createdTime, modifiedTime, parents, mimeType, size)',
      orderBy: 'modifiedTime desc',
      pageSize: 200
    });

    const allFiles = response.result.files || [];
    console.log(`📂 TOUS les fichiers du dossier: ${allFiles.length}`);

    // Exclure seulement les dossiers et fichiers système évidents
    const nonFolderFiles = allFiles.filter(file => {
      const isFolder = file.mimeType === 'application/vnd.google-apps.folder';
      const isGoogleDoc = file.mimeType && file.mimeType.includes('google-apps');

      console.log(`📄 ${file.name} - MimeType: ${file.mimeType || 'inconnu'} - Exclu: ${isFolder || isGoogleDoc}`);

      return !isFolder && !isGoogleDoc;
    });

    console.log(`📋 Fichiers non-dossiers: ${nonFolderFiles.length}`);

    return nonFolderFiles;
  } catch (error) {
    console.error('Erreur lors de la récupération de tous les fichiers:', error);
    throw error;
  }
}

/**
 * Diagnostiquer les permissions d'un dossier
 */
export async function diagnoseFolderPermissions(folderId) {
  try {
    console.log(`🔍 === DIAGNOSTIC DOSSIER ${folderId} ===`);

    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    // 1. Vérifier les infos du dossier lui-même
    try {
      const folderInfo = await gapi.client.drive.files.get({
        fileId: folderId,
        fields: 'id, name, mimeType, parents, capabilities, permissions'
      });

      console.log('📁 Info dossier:', folderInfo.result);
      console.log('🔑 Capacités:', folderInfo.result.capabilities);
    } catch (error) {
      console.error('❌ Impossible d\'accéder aux infos du dossier:', error);
      return { error: 'NO_ACCESS', message: 'Impossible d\'accéder au dossier' };
    }

    // 2. Tester différentes requêtes de listage
    const testQueries = [
      `'${folderId}' in parents and trashed=false`,
      `${folderId} in parents and trashed=false`,
      `parents in "${folderId}" and trashed=false`
    ];

    for (let i = 0; i < testQueries.length; i++) {
      const query = testQueries[i];
      console.log(`🧪 Test requête ${i + 1}: ${query}`);

      try {
        const testResponse = await gapi.client.drive.files.list({
          q: query,
          fields: 'files(id, name, mimeType)',
          pageSize: 10
        });

        console.log(`✅ Requête ${i + 1} fonctionne: ${testResponse.result.files?.length || 0} fichiers`);

        if (testResponse.result.files?.length > 0) {
          return {
            success: true,
            workingQuery: query,
            fileCount: testResponse.result.files.length,
            files: testResponse.result.files
          };
        }
      } catch (error) {
        console.error(`❌ Requête ${i + 1} échoue:`, error);
      }
    }

    return {
      success: true,
      workingQuery: testQueries[0],
      fileCount: 0,
      message: 'Dossier accessible mais vide'
    };

  } catch (error) {
    console.error('❌ Erreur diagnostic:', error);
    return { error: 'UNKNOWN', message: error.message };
  }
}

/**
 * Lister les fichiers JSON dans un dossier (VERSION ULTRA-SIMPLE)
 */
export async function listAppFilesInFolderWithDiagnosis(folderId = null) {
  try {
    console.log(`🔍 RECHERCHE SIMPLE - Dossier: ${folderId}`);

    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    // Requête simple
    const query = folderId ? `'${folderId}' in parents and trashed=false` : 'trashed=false';

    console.log(`🔍 Requête: ${query}`);

    const response = await gapi.client.drive.files.list({
      q: query,
      fields: 'files(id, name, createdTime, modifiedTime, mimeType, size, parents)',
      orderBy: 'modifiedTime desc',
      pageSize: 200
    });

    const allFiles = response.result.files || [];
    console.log(`📂 TOUS les fichiers trouvés: ${allFiles.length}`);

    // Log de CHAQUE fichier
    allFiles.forEach((file, i) => {
      console.log(`${i+1}. "${file.name}" (${file.mimeType || 'pas de type'})`);
    });

    // LOGIQUE ULTRA-SIMPLE : Juste .json à la fin
    const jsonFiles = allFiles.filter(file => {
      const fileName = file.name.toLowerCase();
      const endsWithJson = fileName.endsWith('.json');

      if (endsWithJson) {
        console.log(`✅ TROUVÉ: "${file.name}"`);
      }

      return endsWithJson;
    });

    console.log(`📋 Fichiers .json trouvés: ${jsonFiles.length}`);

    // Enrichir avec le chemin pour les fichiers trouvés
    const enrichedFiles = await Promise.all(jsonFiles.map(async (file) => {
      const path = await getFilePath(file);
      return {
        ...file,
        fullPath: path
      };
    }));

    return enrichedFiles;

  } catch (error) {
    console.error('❌ Erreur listage simple:', error);
    throw error;
  }
}

/**
 * Debug - Informations détaillées sur les fichiers dans un dossier
 */
export async function debugFileDetailsInFolder(folderId) {
  try {
    if (!gapi.client.getToken()) {
      await authenticateUser();
    }

    const query = folderId ? `'${folderId}' in parents and trashed=false` : "trashed=false";

    const response = await gapi.client.drive.files.list({
      q: query,
      fields: 'files(id, name, createdTime, modifiedTime, mimeType, size, fileExtension)',
      orderBy: 'modifiedTime desc'
    });

    const allFiles = response.result.files || [];
    console.log(`📂 Détails des fichiers trouvés: ${allFiles.length}`);

    allFiles.forEach(file => {
      console.log(`  📄 ${file.name} - ${file.mimeType} - ${file.size ? Math.round(file.size/1024) + 'KB' : 'Taille inconnue'}`);
    });

    return allFiles;
  } catch (error) {
    console.error('Erreur lors de la récupération des détails des fichiers:', error);
    throw error;
  }
}

/**
 * Diagnostic complet Google API
 */
export function diagnoseGoogleSetup() {
  console.log('=== DIAGNOSTIC GOOGLE API ===');
  console.log('1. gapi disponible:', typeof gapi !== 'undefined');
  console.log('2. google disponible:', typeof google !== 'undefined');
  console.log('3. CLIENT_ID:', CLIENT_ID);
  console.log('4. Environment:', getCurrentEnvironment());
  console.log('5. Token présent:', gapi?.client?.getToken() ? 'OUI' : 'NON');
  console.log('6. Picker disponible:', typeof google?.picker !== 'undefined');

  if (typeof gapi !== 'undefined' && gapi.client) {
    console.log('7. API initialisée:', isGapiInitialized);
    console.log('8. GIS initialisé:', isGisInitialized);
  }

  return {
    gapi: typeof gapi !== 'undefined',
    google: typeof google !== 'undefined',
    authenticated: gapi?.client?.getToken() ? true : false,
    environment: getCurrentEnvironment()
  };
}

// Ajouter ces imports en haut du fichier avec les autres
import { initDB } from './dbService';

// Ajouter ces 3 fonctions après les constantes existantes (ligne ~20)

/**
 * Sauvegarder le token dans IndexedDB
 */
async function saveGoogleToken(token) {
  try {
    const db = await initDB();
    const transaction = db.transaction(['prefs'], 'readwrite');
    const store = transaction.objectStore('prefs');

    await new Promise((resolve, reject) => {
      const request = store.put({
        id: 'googleToken',
        value: {
          access_token: token.access_token,
          expires_in: token.expires_in,
          scope: token.scope,
          token_type: token.token_type,
          saved_at: Date.now()
        }
      });
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error('Erreur sauvegarde token:', error);
  }
}

/**
 * Charger le token depuis IndexedDB
 */
async function loadGoogleToken() {
  try {
    const db = await initDB();
    const transaction = db.transaction(['prefs'], 'readonly');
    const store = transaction.objectStore('prefs');

    return new Promise((resolve, reject) => {
      const request = store.get('googleToken');
      request.onsuccess = async () => {
        const result = request.result;
        if (result && result.value) {
          const tokenAge = Date.now() - result.value.saved_at;
          const maxAge = 55 * 60 * 1000;

          if (tokenAge < maxAge) {
            resolve(result.value);
          } else {
            console.log('⏰ Token expiré, suppression...');
            // 🔧 CORRIGER : Utiliser clearGoogleToken() au lieu de delete direct
            try {
              await clearGoogleToken();
              resolve(null);
            } catch (deleteError) {
              console.error('Erreur suppression token expiré:', deleteError);
              resolve(null);
            }
          }
        } else {
          resolve(null);
        }
      };
      request.onerror = () => resolve(null);
    });
  } catch (error) {
    console.error('Erreur chargement token:', error);
    return null;
  }
}

/**
 * Supprimer le token stocké
 */
async function clearGoogleToken() {
  try {
    const db = await initDB();
    const transaction = db.transaction(['prefs'], 'readwrite');
    const store = transaction.objectStore('prefs');

    await new Promise((resolve, reject) => {
      const request = store.delete('googleToken');
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error('Erreur suppression token:', error);
  }
}

